import { useEffect, useRef } from 'react';

const useLongHover = (isHovered, onLongHover) => {
  const timerRef = useRef<number | null>(null);
  useEffect(() => {
    if (isHovered) {
      timerRef.current = window.setTimeout(() => {
        onLongHover?.();
      }, 600);
    } else if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHovered]);
};

export default useLongHover;
